<template>
  <div class="order">
    <button
      v-for="(order, index) in list"
      :key="order.id"
      class="order-button"
      :class="{'is-selected': order.selected}"
      @click="$emit('clickedSort', index, 'order')"
    >
      <span class="order-button-icon" />
      <span class="order-button-text" v-text="order.text" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'SortResultSortOrder',
  props: {
    list: {
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.order {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 295/375 * 100%;
  margin: 13/375 * 100% auto 0;
  @include media() {
    max-width: 800px;
    margin: 20px auto 30px;
    justify-content: flex-start;
  }
  &-button {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 140/295 * 100%;
    margin: 7/295 * 100% 0;
    @include media() {
      width: auto;
      margin: 0 20px 0 0;
      cursor: pointer;
    }
    &-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 11/375 * 100vw;
      height: 11/375 * 100vw;
      border: 1px solid #333;
      margin-right: 5/375 * 100vw;
      position: relative;
      @include media() {
        width: 11px;
        height: 11px;
        margin-right: 5px;
      }
      &::before {
        content: '';
        display: block;
        width: 7/375 * 100vw;
        height: 7/375 * 100vw;
        @include media() {
          width: 7px;
          height: 7px;
          transition: .3s ease;
          .order-button:hover & {
            background: #DF0068;
          }
        }
        .is-selected & {
          background: #DF0068;
        }
      }
    }
    &-text {
      font-size: 11/375 * 100vw;
      line-height: 1;
      @include media() {
        font-size: 12px;
      }
    }
  }
}
</style>
